import merge from 'lodash/merge';

import colors from './colors';
import tags from './tags';

const breakpoints = [
  ['phone_small', 320],
  ['phone', 376],
  ['phablet', 576],
  ['tablet', 768],
  ['desktop', 992],
  ['desktop_medium', 1200],
  ['desktop_large', 1400],
];

const fonts = {
  swis: "'Swis721Greek BT', 'sans-serif'",
  swisMd: "'Swis721 Md BT', 'sans-serif'",
  monospace: `"Operator Mono", Consolas, Menlo, Monaco, source-code-pro, Courier New, monospace`,
};

const colorModeTransition =
  'background 0.25s var(--ease-in-out-quad), color 0.25s var(--ease-in-out-quad)';

export default merge({
  initialColorMode: 'light',
  useCustomProperties: true,
  colorModeTransition,
  colors,
  fonts,
  breakpoints,
  tags,
});
